export const tokens = {
    gap: 4,
    usdSize: 18,
    nativeSize: 14,
};
